import React from "react";
import { Container } from "react-bootstrap";
import { Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectCartHidden } from "../../redux/cart/cart.selectors";
import { selectCurrentUser } from "../../redux/user/user.selectors";
import "./header.styles.scss";
import { ReactComponent as WarehouseIllustration } from "../../assets/outside-store.svg";
import { ReactComponent as HearteningLogo } from "../../assets/heartening-logo.svg";
import { ReactComponent as InstagramIcon } from "../../assets/ui-icons/instagram.svg";
// destructure the current user property that we're passing in from our app
class Header extends React.Component {
  constructor(props) {
    super();
    this.state = {
      // Takes active tab from props if it is defined there
      // activeKey: props.activeKey
      // to the element below, add ---> activeKey={this.state.activeKey}
    };

    // Bind the handleSelect function already here (not in the render function)
    //this.handleSelect = this.handleSelect.bind(this);
    // to the element below, add --->  activeStyle={{fontWeight: "bold", color: "red"}}
  }

  render() {
    return (
      <Container fluid className="header">
        <div className="sky-background"></div>

        <a href="https://www.heartening.org/">
          <div className="heartening-logo-stamp">
            <HearteningLogo
              className="heartening-logo"
              width="30px"
              height="30px"
            ></HearteningLogo>
            <p className="logo-url-text d-none d-md-block">heartening.org</p>
          </div>
        </a>

        <a href="https://www.heartening.org/">
          <div className="heartening-logo-stamp">
            <div className="heartening-logo-container">
              <HearteningLogo
                className="heartening-logo"
                width="48px"
                height="48px"
              ></HearteningLogo>
            </div>
            <p className="logo-url-text d-none d-md-block">heartening</p>
          </div>
        </a>

        {/* BOOK A PICK UP CTA */}
        {/* <div className="book-a-pick-up">
          <a
            className="book-a-pick-up-link"
            href="https://calendly.com/heartening-donations/donation-pickup"
            target="_blank"
          >
            book a pick-up
          </a>
        </div> */}

        {/* TOP-RIGHT LINKS: DROP OFF / ABOUT / INSTAGRAM */}
        <div className="top-links-nav">
          <a
            className="top-link"
            href="https://calendly.com/heartening-donations/drop-off-donations-at-heartening-s-warehouse"
            target="_blank"
            rel="noopener noreferrer"
          >
            drop off donations
          </a>
          <span className="top-link-divider" aria-hidden="true">
            &bull;
          </span>
          <a
            className="top-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://heartening.org/about"
          >
            about
          </a>
          <span className="top-link-divider" aria-hidden="true">
            &bull;
          </span>
          <a
            className="top-link top-link-icon"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/hearteningaustin/"
            aria-label="Instagram"
          >
            <InstagramIcon className="instagram-icon" width="18px"></InstagramIcon>
          </a>
        </div>

        <div className="thick-ribbon">
          <div className="header-center-anchor">
            <Switch>
              <Route path="/:id" />
            </Switch>
          </div>
        </div>
        <WarehouseIllustration className="warehouse-illustration" />
        <div className="heartening-explanation">
          <p className="mission-statement">
            Heartening's mission is to put clothing back into the local
            community as affordably and sustainably as possible.
          </p>
          <p>
            Open to all for shopping and donation drop-offs Tuesday-Friday 11a-7p and Saturday-Sunday 10a-6p.
          </p>

          <p>
            <a
              className="google-maps-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://g.co/kgs/CvXCNSo"
            >
              650 Canion St, Austin, TX 78752
            </a>
          </p>
        </div>
      </Container>
    );
  }

  handleSelect(selectedKey) {
    // The active tab must be set into the state so that
    // the Tabs component knows about the change and re-renders.
    this.setState({
      activeKey: selectedKey,
    });
  }
}
// this will return an object with the value we want
// state is the top level root reducer
// we want the rootreducer: then the user reducer: then the currentUser value
// the nested destructuring syntax means 'take the currentUser value off of the user value off of the state'
const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  hidden: selectCartHidden,
});

// the first argument is the function that allows us to access the state, with the state being our rootreducer
export default connect(mapStateToProps)(Header);
